import { Flex, FlexProps } from "@chakra-ui/react";
import React from "react";
import { TransactionOverviewPaddingX } from "./SectionTitle";

export function TableHeaderRow(props: FlexProps): React.ReactElement {
  return (
    <Flex
      w="full"
      px={TransactionOverviewPaddingX}
      py={1}
      gap={6}
      borderTopWidth="1px"
      borderBottomWidth="1px"
      backgroundColor="gray.50"
      {...props}
    />
  );
}

export function TableHeaderCell(props: FlexProps): React.ReactElement {
  return (
    <Flex
      flexGrow={1}
      flexShrink={1}
      flexBasis={0}
      minW={0}
      fontWeight="semibold"
      fontSize="sm"
      {...props}
    />
  );
}

export function TableRow(props: FlexProps): React.ReactElement {
  return (
    <Flex
      w="full"
      px={TransactionOverviewPaddingX}
      py={2}
      gap={6}
      borderBottomWidth="1px"
      borderBottomColor="gray.100"
      align="center"
      {...props}
    />
  );
}

export function TableCell(props: FlexProps): React.ReactElement {
  return (
    <Flex
      flexGrow={1}
      flexShrink={1}
      flexBasis={0}
      minW={0}
      align="center"
      {...props}
    />
  );
}
